module.exports = __webpack_public_path__ + "img/Bean-3.94301bb4.svg";